export default {
	editGuide: "Editar Relacionamento",
	assignGuide: "Vincular Guia",
	tabs: {
		link: "Existente",
		createNew: "Criar novo",
	},
	filters: {
		active: "Ativos",
	},
};
